export default __webpack_public_path__ + "static/media/icon_truck.74b279c7.svg";